import React, { Component } from "react";
import SFMic from "./Mic/Mic";
import Predsearch from "./Predsearch";
import MenuBlock from "../../BaseComponents/MenuBlock";
import General from "../../../Utils/General";
// import FileUploadBlock from "../../BaseComponents/FileUpload"
import styled from "styled-components";

let Mic = SFMic.Mic;

interface IProps {
  chatInput;
  chatInputDisplayValue;
  handleInput;
  handleFocus;
  handleKeyUp;
  handleKeyDown;
  isSpeech;
  predSearchToggle;
  predSearchResponse;
  togglePredSearch;
  assignPredSearchQues;
  handleSubmit;
  isInputDisabled;
  numbersOnly;
  isPushBotVisible;
}

interface IState {
  isMenuVisible: boolean;
  value: string;
  showMsg: boolean;
  placeholderIndex: number;
}

class ChatInput extends Component<IProps, IState> {
  placeholderInterval: any;
  constructor(props) {
    super(props);
    this.state = {
      isMenuVisible: false,
      value: "",
      showMsg: false,
      placeholderIndex: 0,
    };
    this.placeholderInterval = null;
  }
  placeholderArray = [
    "Start a conversation",
    "Apply for Credit Card...",
    "Banking Services...",
    "Balance and Statement...",
  ];

  componentDidMount() {
    let input = document.getElementById("chatInput");
    // /^[0-9]+$/
    // /^[^*|\":<>[\]{}`\\()';&$~\^]*$/
    General.setInputFilter(input, function (value) {
      return /^[^*|\":<>[\]{}`\\()';&$~#%+!=_\^]*$/.test(value); // Allow digits and '.' only, using a RegExp
    }); //allow @ - / block  !"#$%&'()*+:;<>=\|[]{}^~`_

    // this.placeholderInterval = setInterval(() => {
    //   this.setState((prevState) => ({
    //     placeholderIndex:
    //       (prevState.placeholderIndex + 1) % this.placeholderArray.length,
    //   }));
    // }, 3000);
  }

  //   componentWillUnmount() {
  //     this.placeholderInterval && clearInterval(this.placeholderInterval);
  //   }

  toggleMenu = () => {
    this.setState({
      isMenuVisible: !this.state.isMenuVisible,
    });
  };
  preventNumbers(ev) {
    // if (this.props.numbersOnly && !((ev.charCode >= 48 && ev.charCode <= 57) || ev.charCode == 46)) {
    //   ev.preventDefault();
    // }
  }

  handleSubmit() {
    //Imitate onKeyUp == enter Event (new Event has no support in IE)
    //A very bad way to do Event
    this.props.handleKeyUp.call(this, { keyCode: 13 }, "UserText");
  }

  handleInputKeyUp(ev) {
    if (ev.target.value.length > 119) {
      this.setState({
        showMsg: true,
      });

      setTimeout(() => {
        this.setState({
          showMsg: false,
        });
      }, 3000);
    }
  }

  render() {
    return (
      <React.Fragment>
        {/* <FileUploadBlock isFileUploadBlockVisible={this.props.isFileUploadBlockVisible} toggleFileUploadBlock={this.props.toggleFileUploadBlock} handleSubmit={this.props.handleSubmit}></FileUploadBlock> */}
        {!this.props.isInputDisabled ? (
          <div className="sf-chatinput-wrapper">
            {this.props.isPushBotVisible &&
            !window.location.href.includes("pb/RBLCares") ? null : (
              <MenuBlock
                toggleMenu={this.toggleMenu}
                isMenuVisible={this.state.isMenuVisible}
                handleFocus={this.props.handleFocus} //
              />
            )}

            <div
              style={{
                position: "absolute",
                padding: "8px 10px",
                background: "#2c387a",
                borderRadius: "8px 8px 0px",
                top: "-35px",
                right: "9px",
                zIndex: 100,
                fontSize: "13px",
                color: "#fff",
                display: this.state.showMsg ? "block" : "none",
              }}
            >
              Please describe your query within 120 characters.
            </div>

            <input
              autoComplete="off"
              id="chatInput"
              type="text"
              maxLength={120}
              className="sf-chatinput"
              placeholder={this.placeholderArray[this.state.placeholderIndex]}
              value={this.props.chatInput}
              onChange={this.props.handleInput}
              onFocus={() => {
                this.props.handleFocus();
                // this.setState({
                //     isMenuVisible: false
                // });
              }}
              // onKeyPress={(ev) => this.preventNumbers(ev)}
              onKeyPress={(ev) => this.handleInputKeyUp(ev)}
              onKeyUp={this.props.handleKeyUp}
              onKeyDown={this.props.handleKeyDown}
            />
            <Predsearch
              predSearchToggle={this.props.predSearchToggle}
              predSearchResponse={this.props.predSearchResponse}
              togglePredSearch={this.props.togglePredSearch}
              assignPredSearchQues={this.props.assignPredSearchQues}
            />
            {/* Has a bug , 'Click Mic to start recording and the  startTyping to bring the send button and 
                    the remove all typed to see mic icon that you can't click because it is still recording
                    . After some time when recording pauses then you will be able to type
                ' */}
            <Mic
              {...this.props}
              handleSubmit={this.handleSubmit}
              isSpeech={this.props.isSpeech}
            />
          </div>
        ) : null}
      </React.Fragment>
    );
  }
}

export default ChatInput;
